import { proxy } from 'valtio'

export const redirectTo = proxy<{ address: string | null }>({ address: null })